import PublicIcon from '@mui/icons-material/Public';

export interface Company {
    name: string
    jobScannerKey: string
    new: boolean
}
export interface JobListing {
    url: string
    title: string
    location: string | null
    category: string | null
}

export interface JobScannerResult {
    timestamp: string
    company: string
    jobsFound: number
    jobs: JobListing[]
}

export interface JobScannerBatchResult {
    [key: string]: JobScannerResult
}

export interface JobScannerConfig {
    name: string
}

export interface JobsSummaryDocument {
    companyName: string,
    jobScannerKey: string,
    scanResultsLatest: JobScannerResult
    scanResultsPrevious: JobScannerResult
    advertsTotal: number
    advertsNewTotal: number
    advertsClosedTotal: number
    adverts: JobListing[]
    advertsNew: JobListing[]
    advertsClosed: JobListing[]
}

export interface JobsBatchSummary {
    [key: string]: JobsSummaryDocument
}

export type JobListingStatus = "New" | "Closed" | "Open";

export interface RegionDetails {
    regionName: string,
    regionShortName: string,
    regionKey: string,
    icon?: React.ReactNode,
    imageUrl?: string
}

export const AllRegions: RegionDetails[] = [
    {
        regionName: "All",
        regionKey: "",
        regionShortName: "",
        imageUrl: undefined,
        icon: <PublicIcon style={{ fontSize: "24px" }} />
    },
    {
        regionName: "Australia",
        regionShortName: "AUS",
        regionKey: "AUS",
        imageUrl: "https://hatscripts.github.io/circle-flags/flags/au.svg",
        icon: undefined
    },
    {
        regionName: "Hong Kong",
        regionKey: "Hong_Kong",
        regionShortName: "HK",
        imageUrl: "https://hatscripts.github.io/circle-flags/flags/hk.svg",
        icon: undefined
    },
    {
        regionName: "Singapore",
        regionKey: "Singapore",
        regionShortName: "SG",
        imageUrl: "https://hatscripts.github.io/circle-flags/flags/sg.svg",
        icon: undefined
    },
    {
        regionName: "Europe",
        regionKey: "Europe",
        regionShortName: "EUR",
        // imageUrl: "https://hatscripts.github.io/circle-flags/flags/eu.svg",
        imageUrl: "https://react-circle-flags.pages.dev/uk.svg",
        icon: undefined
    },
    {
        regionName: "USA",
        regionKey: "USA",
        regionShortName: "USA",
        imageUrl: "https://hatscripts.github.io/circle-flags/flags/us.svg",
        icon: undefined
    },
    {
        regionName: "APAC",
        regionKey: "APAC",
        regionShortName: "APAC",
        icon: <PublicIcon style={{ fontSize: "24px" }} />,
        imageUrl: undefined,
    }
];
